import TagManager from 'react-gtm-module';

import {
  DeferredNavigationProps,
  deferredNavigationFields,
} from './clickTracking';

/** The page type a Category Navigation section is rendered on. */
export type CategoryNavigationLocation =
  | 'cip'
  | 'clp'
  | 'plp_top'
  | 'plp_after_deals'
  | 'plp_bottom'
  | 'homepage';

export interface TrackCategoryNavClickProps extends DeferredNavigationProps {
  data: {
    interactionLocation: CategoryNavigationLocation;
    /** Path the click happened on, without its query string. */
    eventPage: string;
    /** Locale-prefixed href the link navigates to */
    linkUrl: string;
    /** The tile label, or the SHOP ALL link's rendered text */
    linkText: string;
    /** The section's heading, telling apart two sections on one page */
    heading: string;
    /** 0-based tile position; `null` for the SHOP ALL link, which isn't a tile */
    index: number | null;
  };
}

/**
 * ED-425 — Category Navigation Tiles clicks (tiles and SHOP ALL).
 */
export const trackCategoryNavClick = ({
  data,
  ...deferral
}: TrackCategoryNavClickProps) => {
  const { interactionLocation, eventPage, linkUrl, linkText, heading, index } =
    data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_cat_nav',
      interaction: {
        interaction_location: interactionLocation,
        event_page: eventPage,
        link_url: linkUrl,
        link_text: linkText,
        heading,
        // Tiles link to categories, never a single brand.
        coop_brand: null,
        // Sent as a string to match the ticket spec and the other nav events.
        index: index === null ? null : index.toString(),
      },
      ...deferredNavigationFields(deferral),
    },
  });
};
